module.exports = __webpack_public_path__ + "static/media/meh-new.6593b69d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/meh-new.svg
// module id = 812
// module chunks = 0